module.exports = __webpack_public_path__ + "img/1528020750.d788f972.jpg";